import { Image, Modal } from "@mantine/core";

export function ImageLightbox({ opened, onClose, src, alt }) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      padding={0}
      size="auto"
      radius="lg"
      overlayProps={{ backgroundOpacity: 0.72, blur: 4 }}
      styles={{ content: { background: "transparent", boxShadow: "none" } }}
    >
      <Image
        src={src}
        alt={alt}
        fit="contain"
        radius="lg"
        mah="70vh"
        maw="min(440px, 90vw)"
        onClick={onClose}
        style={{ cursor: "zoom-out" }}
      />
    </Modal>
  );
}
